<div class="container-fluid">
  <div class="row">
    <div class="col-12 px-0">
      <div class="card p-0 border-0 animate-fade-in">
        <div class="card-body p-3">
          <!-- Header -->
          <div class="d-flex flex-row flex-wrap justify-content-between align-items-center mb-2">
            <div class="d-flex align-items-center">
              <button class="btn btn-icon me-3 border" routerLink="/farmers">
                <i class="bi bi-arrow-left"></i>
              </button>
              <div>
                <h1 class="card-title mb-1">Employee Wise Farmers Visits</h1>
                <span class="sub-text">View farmers and visit history by employee</span>
              </div>
            </div>

            @if (selectedEmployee && currentView === viewState.FARMERS) {
              <button
                class="btn btn-soft-primary d-flex align-items-center gap-2"
                (click)="onExportEmployeeFarmers()"
                [disabled]="isExportingFarmers">
                @if (isExportingFarmers) {
                  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  Exporting...
                } @else {
                  <i class="bi bi-download"></i>
                  Export Farmers
                }
              </button>
            }
          </div>

          <!-- Breadcrumb -->
          <nav aria-label="breadcrumb" class="mb-4">
            <ol class="breadcrumb mb-0">
              <li class="breadcrumb-item" [class.active]="currentView === viewState.EMPLOYEES">
                <a href="javascript:void(0)" (click)="backToEmployees()">Employees</a>
              </li>
              <li class="breadcrumb-item" *ngIf="selectedEmployee" [class.active]="currentView === viewState.FARMERS">
                <a href="javascript:void(0)" (click)="backToFarmers()">{{ selectedEmployee.user.full_name }}</a>
              </li>
              <li class="breadcrumb-item active" *ngIf="selectedFarmer" aria-current="page">
                {{ selectedFarmer.full_name }} (Visits)
              </li>
            </ol>
          </nav>

          @if (isLoading) {
            <app-loading-spinner></app-loading-spinner>
          } @else {
            <!-- View 1: Employees List -->
            @if (currentView === viewState.EMPLOYEES) {
              <!-- Search Bar -->
              <div class="row mb-3">
                <div class="col-12 px-0">
                  <div class="input-group">
                    <span class="input-group-text bg-white border-end-0">
                      <i class="bi bi-search text-muted"></i>
                    </span>
                    <input
                      type="text"
                      class="form-control border-start-0"
                      placeholder="Search employees..."
                      [(ngModel)]="searchTerm"
                      (keyup)="onSearchKeyUp()" />
                  </div>
                </div>
              </div>

              @if (employees.length === 0) {
                <div class="empty-state-container my-5">
                  <i class="bi bi-people"></i>
                  <h5 class="text-dark fw-bold">No Employees Found</h5>
                  <p class="text-muted">There are no employees available to display.</p>
                </div>
              } @else {
                <div class="table-responsive">
                  <table class="table table-hover align-middle mb-0">
                    <thead class="bg-light">
                      <tr>
                        <th class="border-0 text-uppercase small fw-bold text-muted">Employee Name</th>
                        <th class="border-0 text-uppercase small fw-bold text-muted">Designation</th>
                        <th class="text-end border-0 text-uppercase small fw-bold text-muted">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let emp of employees">
                        <td class="fw-semibold">{{ emp.user.full_name }}</td>
                        <td class="text-muted">{{ emp.designation.title }}</td>
                        <td class="text-end">
                          <button class="btn btn-sm btn-soft-primary" (click)="selectEmployee(emp)">
                            View Farmers
                            <i class="bi bi-chevron-right"></i>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="mt-4">
                  <app-pagination
                    [currentPage]="employeesPage.page"
                    [totalCount]="employeesPage.total"
                    [pageSize]="pageSize"
                    [hasNextPage]="employeesPage.hasNext"
                    [hasPreviousPage]="employeesPage.hasPrev"
                    (pageChange)="onEmployeesPageChange($event)"></app-pagination>
                </div>
              }
            }

            <!-- View 2: Farmers List -->
            @if (currentView === viewState.FARMERS) {
              @if (farmers.length === 0) {
                <div class="empty-state-container my-5">
                  <i class="bi bi-person-video2"></i>
                  <h5 class="text-dark fw-bold">No Farmers Found</h5>
                  <p class="text-muted">No farmers are associated with this employee.</p>
                </div>
              } @else {
                <div class="table-responsive">
                  <table class="table table-hover align-middle mb-0">
                    <thead class="bg-light">
                      <tr>
                        <th class="border-0 text-uppercase small fw-bold text-muted">Farmer Name</th>
                        <th class="border-0 text-uppercase small fw-bold text-muted">Village</th>
                        <th class="border-0 text-uppercase small fw-bold text-muted">Taluka</th>
                        <th class="border-0 text-uppercase small fw-bold text-muted">District</th>
                        <th class="border-0 text-uppercase small fw-bold text-muted">Mobile Number</th>
                        <th class="border-0 text-uppercase small fw-bold text-muted">Last Visited Date</th>
                        <th class="text-end border-0 text-uppercase small fw-bold text-muted">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let farmer of farmers">
                        <td class="fw-semibold">{{ farmer.full_name }}</td>
                        <td class="text-muted">{{ farmer.vilage }}</td>
                        <td class="text-muted">{{ farmer.taluka }}</td>
                        <td class="text-muted">{{ farmer.district }}</td>
                        <td class="text-muted">{{ farmer.mobile_number }}</td>
                        <td class="text-muted">
                          @if (farmer.last_visit_date) {
                            {{ farmer.last_visit_date | date }}
                          } @else {
                            <span class="app-badge badge-warning">Not visited yet</span>
                          }
                        </td>
                        <td class="text-end">
                          <button class="btn btn-sm btn-soft-primary" (click)="selectFarmer(farmer)">
                            View Visits
                            <i class="bi bi-chevron-right"></i>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <div class="mt-4">
                  <app-pagination
                    [currentPage]="farmersPage.page"
                    [totalCount]="farmersPage.total"
                    [pageSize]="pageSize"
                    [hasNextPage]="farmersPage.hasNext"
                    [hasPreviousPage]="farmersPage.hasPrev"
                    (pageChange)="onFarmersPageChange($event)"></app-pagination>
                </div>
              }
            }

            <!-- View 3: Visit History -->
            @if (currentView === viewState.VISITS) {
              <!-- Farmer the visits belong to -->
              @if (selectedFarmer) {
                <div class="border bg-light p-3 mb-3">
                  <div class="row g-3">
                    <div class="col-12 col-md-3">
                      <span class="text-uppercase small fw-bold text-muted">Farmer</span>
                      <div class="fw-bold text-dark">{{ selectedFarmer.full_name }}</div>
                      <div class="small text-muted">
                        <i class="bi bi-telephone me-1"></i>
                        {{ selectedFarmer.mobile_number }}
                        @if (
                          selectedFarmer.whatsapp_number &&
                          selectedFarmer.whatsapp_number !== selectedFarmer.mobile_number
                        ) {
                          <span class="ms-2">
                            <i class="bi bi-whatsapp me-1"></i>
                            {{ selectedFarmer.whatsapp_number }}
                          </span>
                        }
                      </div>
                    </div>

                    <div class="col-12 col-md-3">
                      <span class="text-uppercase small fw-bold text-muted">Location</span>
                      <div class="text-dark">{{ selectedFarmer.vilage }}, {{ selectedFarmer.taluka }}</div>
                      <div class="small text-muted">
                        {{ selectedFarmer.district }}, {{ selectedFarmer.state }} {{ selectedFarmer.pincode }}
                      </div>
                    </div>

                    <div class="col-6 col-md-2">
                      <span class="text-uppercase small fw-bold text-muted">Land Size</span>
                      <div class="fw-semibold text-dark">{{ selectedFarmer.land_size }} acres</div>
                    </div>

                    <div class="col-6 col-md-2">
                      <span class="text-uppercase small fw-bold text-muted">Visits Recorded</span>
                      <div class="fw-semibold text-dark">{{ visitsPage.total }}</div>
                    </div>

                    <div class="col-12 col-md-2">
                      <span class="text-uppercase small fw-bold text-muted">Dealer</span>
                      @if (selectedFarmer.dealer) {
                        <div class="fw-semibold text-dark">{{ selectedFarmer.dealer.shop_name }}</div>
                        <div class="small text-muted">
                          {{ selectedFarmer.dealer.first_name }} {{ selectedFarmer.dealer.last_name }}
                        </div>
                      } @else {
                        <div class="text-muted">-</div>
                      }
                    </div>

                    @if (selectedFarmer.crops_grown.length > 0) {
                      <div class="col-12">
                        <span class="text-uppercase small fw-bold text-muted">Crops Grown</span>
                        <div class="d-flex flex-wrap gap-1 mt-1">
                          @for (crop of selectedFarmer.crops_grown; track crop) {
                            <span class="app-badge badge-secondary">{{ crop }}</span>
                          }
                        </div>
                      </div>
                    }
                  </div>
                </div>
              }

              @if (visits.length === 0) {
                <div class="empty-state-container my-5">
                  <i class="bi bi-person-walking"></i>
                  <h5 class="text-dark fw-bold">No Visits Found</h5>
                  <p class="text-muted">No visit history found for this farmer.</p>
                </div>
              } @else {
                <div class="d-flex flex-column gap-3">
                  @for (visit of visits; track visit.id; let i = $index) {
                    <div class="card border shadow-sm">
                      <!-- Visit date leads the card -->
                      <div class="card-header bg-white py-3">
                        <div class="d-flex flex-wrap justify-content-between align-items-center gap-2">
                          <div class="d-flex align-items-center gap-3">
                            <div class="text-center border bg-light px-3 py-2" style="min-width: 62px">
                              <div class="fw-bold text-dark lh-1" style="font-size: 1.15rem">
                                {{ visit.created_at | date: 'dd' }}
                              </div>
                              <div class="text-uppercase text-muted" style="font-size: 0.7rem">
                                {{ visit.created_at | date: 'MMM yyyy' }}
                              </div>
                            </div>
                            <div>
                              <div class="fw-bold text-dark">{{ visit.created_at | date: 'EEEE, dd MMM yyyy' }}</div>
                              <div class="small text-muted">
                                <i class="bi bi-clock me-1"></i>
                                {{ visit.created_at | date: 'h:mm a' }}
                              </div>
                            </div>
                          </div>

                          <div class="d-flex align-items-center gap-2">
                            @if (visit.purpose_of_visit) {
                              <span class="app-badge badge-soft-primary">{{ visit.purpose_of_visit }}</span>
                            }
                            <span class="text-muted small">Visit #{{ visitNumber(i) }}</span>
                          </div>
                        </div>
                      </div>

                      <div class="card-body">
                        <div class="row g-3">
                          <!-- Visited by -->
                          <div class="col-12 col-md-4">
                            <span class="text-uppercase small fw-bold text-muted">Visited By</span>
                            <div class="d-flex align-items-center gap-2 mt-1">
                              <i class="bi bi-person-badge text-primary fs-5"></i>
                              <div>
                                <div class="fw-semibold text-dark">{{ visit.employee.full_name }}</div>
                                <div class="small text-muted">
                                  {{ visit.employee.employee?.designation?.title || 'Employee' }}
                                  @if (visit.employee.phone_number) {
                                    &middot; {{ visit.employee.phone_number }}
                                  }
                                </div>
                              </div>
                            </div>
                          </div>

                          <!-- Purpose -->
                          <div class="col-12 col-md-3">
                            <span class="text-uppercase small fw-bold text-muted">Purpose</span>
                            <div class="mt-1 text-dark">{{ visit.purpose_of_visit || '-' }}</div>
                          </div>

                          <!-- Crops discussed -->
                          <div class="col-12 col-md-5">
                            <span class="text-uppercase small fw-bold text-muted">Crops Discussed</span>
                            <div class="mt-1 d-flex flex-wrap gap-1">
                              @if (visit.crops.length > 0) {
                                @for (crop of visit.crops; track crop) {
                                  <span class="app-badge badge-soft-success">{{ crop }}</span>
                                }
                              } @else {
                                <span class="text-muted">-</span>
                              }
                            </div>
                          </div>

                          <!-- Products recommended -->
                          <div class="col-12 col-md-6">
                            <span class="text-uppercase small fw-bold text-muted">Products Recommended</span>
                            @if (visit.products_recommended.length > 0) {
                              <ul class="list-unstyled mt-1 mb-0">
                                @for (product of visit.products_recommended; track product.id) {
                                  <li class="d-flex align-items-start gap-2 py-2 border-bottom">
                                    <i class="bi bi-box-seam text-primary mt-1"></i>
                                    <div>
                                      <span class="fw-semibold">{{ product.name }}</span>
                                      @if (product.product_category) {
                                        <span class="app-badge badge-secondary ms-2">
                                          {{ product.product_category.name }}
                                        </span>
                                      }
                                      @if (product.contents) {
                                        <div class="small text-muted">{{ product.contents }}</div>
                                      }
                                      @if (product.company) {
                                        <div class="small text-muted">{{ product.company.name }}</div>
                                      }
                                    </div>
                                  </li>
                                }
                              </ul>
                            } @else {
                              <p class="text-muted mt-1 mb-0">None recommended on this visit</p>
                            }
                          </div>

                          <!-- Notes -->
                          <div class="col-12 col-md-6">
                            <span class="text-uppercase small fw-bold text-muted">Visit Notes</span>
                            @if (visit.visit_notes) {
                              <p class="mt-1 mb-0">{{ visit.visit_notes }}</p>
                            } @else {
                              <p class="text-muted mt-1 mb-0">No notes recorded</p>
                            }
                          </div>

                          <!-- Images -->
                          <div class="col-12">
                            <span class="text-uppercase small fw-bold text-muted">
                              Images
                              @if (visit.images.length > 0) {
                                ({{ visit.images.length }})
                              }
                            </span>
                            @if (visit.images.length > 0) {
                              <div class="d-flex flex-wrap gap-2 mt-2">
                                @for (img of visit.images; track img) {
                                  <a [href]="img" target="_blank" rel="noopener">
                                    <img
                                      [src]="img"
                                      alt="Visit image"
                                      class="rounded border object-fit-cover"
                                      style="width: 100px; height: 100px" />
                                  </a>
                                }
                              </div>
                            } @else {
                              <p class="text-muted mt-1 mb-0">No images uploaded</p>
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                </div>

                <div class="mt-4">
                  <app-pagination
                    [currentPage]="visitsPage.page"
                    [totalCount]="visitsPage.total"
                    [pageSize]="pageSize"
                    [hasNextPage]="visitsPage.hasNext"
                    [hasPreviousPage]="visitsPage.hasPrev"
                    (pageChange)="onVisitsPageChange($event)"></app-pagination>
                </div>
              }
            }
          }
        </div>
      </div>
    </div>
  </div>
</div>
